import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TripSummaryComponent } from "./trip-summary.component";
import { TripSummaryRoutingModule } from "./trip-summary-routing.module";
import { FlightResultModule } from "src/app/pages/flights-page/src/app/ui/components/flight-result/flight-result.module";
import { EventPageModule } from "src/app/pages/events/src/app/ui/event-page.module";
import { LoaderModule } from "src/app/libs/ui/components/loader/loader.module";
import { EventSummaryCardModule } from "src/app/libs/ui/components/event-summary-card/event-summary-card.module";
import { CurrencyExchangeConverterModule } from "src/app/libs/common/pipes/currency-exhange-converter/currency-exhange-convertermodule";
import { HotelStarsModule } from "src/app/libs/ui/components/hotel-stars/hotel-stars.module";
import { SummaryCardModule } from "../../../../../libs/ui/components/summary-card/summary-card.module";
import { I18nModule } from "src/app/core/languages-support/i18n.module";
import { AppSupportedLanguages } from "src/app/core/languages-support/i18n-config.service";
import { FlightsPageComponent } from "src/app/pages/flights-page/src/app/ui/flights-page.component";
import { FlightsPageModule } from "src/app/pages/flights-page/src/app/ui/flights-page.module";
import { MatTooltipModule } from "@angular/material/tooltip";

@NgModule({
    declarations: [TripSummaryComponent],
    imports: [
        CommonModule,
        TripSummaryRoutingModule,
        FlightResultModule,
        EventPageModule,
        LoaderModule,
        HotelStarsModule,
        EventSummaryCardModule,
        I18nModule.forRoot(AppSupportedLanguages),
        CurrencyExchangeConverterModule,
        SummaryCardModule,
        FlightsPageModule,
        MatTooltipModule,
    ]
})
export class TripSummaryModule {}
